import { render, staticRenderFns } from "./CampaignDuration.vue?vue&type=template&id=d1342ba4&"
import script from "./CampaignDuration.vue?vue&type=script&lang=js&"
export * from "./CampaignDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports